module.exports = __webpack_public_path__ + "img/banner-cesfam.a712230f.png";